module.exports = __webpack_public_path__ + "static/media/stripchat.8b0d8d3a.png";